<template>
  <div>
    <div>
      <signal-banner v-if="step === 1 && signal"></signal-banner>
      <div class="mt-12 mb-2 d-flex">
        <h1 class="ang-heading" v-if="base">Formularz aktualizacji klienta</h1>
        <h1 class="ang-heading" v-else>Formularz rejestracji klienta</h1>
        <button
          type="submit"
          class="btn ang-button ang-btn-lg ml-auto mb-4 d-none d-md-none d-lg-block"
          @click="step = 2"
          v-if="step === 1 && !base"
        >
          Mam już kod z SMS
        </button>
      </div>
      <update-code
        :base="base"
        v-if="base && step === 0"
        @clientVerified="clientVerified"
        type="client_update"
        url="/client"
      ></update-code>
      <aegon-form
        v-if="step === 1 && aegon"
        :base="base"
        :code="code"
        :solicitor="solicitor"
        :biznes="biznes"
        :client="client"
        @clientUpdated="clientUpdated"
        :mode="mode"
      ></aegon-form>
      <ang-form
        v-else-if="step === 1"
        :base="base"
        :code="code"
        :solicitor="solicitor"
        :client="client"
        @clientUpdated="clientUpdated"
      ></ang-form>
      <sms-form
        :client="client"
        v-if="step === 2"
        :base="base"
        @return="step = 1"
        :solicitor="solicitor"
        @code="setCode"
      ></sms-form>
      <sum-mary
        :client="client"
        :signal="signal"
        :data="data"
        v-if="step === 3"
        :base="base"
        :solicitor="solicitor"
        :code="code"
      ></sum-mary>
    </div>
  </div>
</template>

<script>
// import spinner from "./partials/misc/spinner"
import smsForm from "./partials/forms/registration/smsForm";
import summary from "./partials/forms/registration/summary";
import updateCode from "./partials/forms/update-code";
import angForm from "./partials/forms/registration/ang-form";
import aegonForm from "./partials/forms/registration/aegon-form";
import signalBanner from "./partials/forms/registration/signal-banner";
import moment from "moment";
import api from "@/services/api";
import tippy from "tippy.js";

export default {
  data() {
    return {
      mode: "klient",
      solicitor: null,
      base: null,
      code: null,
      biznes: false,
      client: {},
      step: null,
      error: null,
      aegon: false,
      signal: false,
      data: {
        url: null,
      },
    };
  },
  components: {
    "sms-form": smsForm,
    "sum-mary": summary,
    "update-code": updateCode,
    "ang-form": angForm,
    "aegon-form": aegonForm,
    "signal-banner": signalBanner,
  },
  name: "ClientRegisterForm",
  mounted() {
    tippy("[data-tippy-content]");
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
  },
  methods: {
    getData() {
      let self = this;

      api.get(
        "/client/" + self.base,
        { code: this.code },
        function (data) {
          localStorage.setItem(self.base, self.code);
          localStorage.setItem("client_update", moment().format("YYYY-MM-DD"));
          self.clientVerified(data, self.code);
        },
        function () {
          localStorage.removeItem(self.base);
          localStorage.removeItem("client_update");
          self.step = 0;
        }
      );
    },
    clientVerified(client, code) {
      this.client = client;
      this.code = code;
      this.step = 1;
    },
    init() {
      let self = this;
      localStorage.removeItem("clientType");
      localStorage.removeItem("clientTypeExp");
      if (window.location.host.split(".").indexOf("aegon") >= 0) {
        this.mode = "aegon";
        this.aegon = true;
      }
      if (window.location.host.split(".").indexOf("profitowi") >= 0) {
        this.mode = "profitowi";
        this.aegon = true;
      }
      if (window.location.host.split(".").indexOf("as") >= 0) {
        this.mode = "as";
        this.aegon = true;
      }

      if (typeof this.$route.params.solicitor !== "undefined") {
        this.solicitor = this.$route.params.solicitor;
      } else if (typeof this.$route.query.solicitor !== "undefined") {
        this.solicitor = this.$route.query.solicitor;
      } else if (typeof this.$route.query.uid !== "undefined") {
        this.solicitor = this.$route.query.uid;
      }

      if (this.solicitor === "biznes") {
        this.biznes = true;
        this.solicitor = "kontakt.biznes";
      } else if (this.$route.meta.biznes) {
        this.biznes = true;
      }
      if (this.solicitor === "kredyty") {
        this.biznes = false;
        this.solicitor = "leady.kredyty";
      }

      if (window.location.host.split(".").indexOf("signal") >= 0) {
        this.mode = "signal";
        this.signal = true;

        if (!this.solicitor) {
          window.location.href = "https://grupaang.pl";
          return;
        }

        api.get(
          "/url/signal?solicitor=" + this.solicitor,
          {},
          function (data) {
            self.data.url = data.url;
          },
          function () {
            window.location.href = "https://grupaang.pl";
            return;
          }
        );
      }

      if (typeof this.$route.params.base !== "undefined") {
        this.base = this.$route.params.base;
      } else if (typeof this.$route.query.base !== "undefined") {
        this.base = this.$route.query.base;
      }
      if (this.base && this.base.length > 0) {
        let code = localStorage.getItem(this.base);
        let date = localStorage.getItem("client_update");
        if (code && date === moment().format("YYYY-MM-DD")) {
          this.code = code;
          this.getData();
        } else {
          this.step = 0;
        }
      } else {
        this.step = 1;
      }

      if (this.aegon && !this.solicitor) {
        window.location.href = "https://grupaang.pl";
      }

      this.$forceUpdate();
    },
    clientUpdated(client, verification_required) {
      this.client = client;
      if (verification_required) {
        this.step = 2;
      } else {
        this.step = 3;
      }
    },
    setCode(code) {
      this.code = code;
      this.step = 3;
    },
  },
};
</script>
